/**
 * German-style EUR formatter. Always returns
 *   1.234,56 €
 *   0,00 €
 *
 * Thousand separator = dot, decimal separator = comma, symbol after the
 * number with a non-breaking space. Use this everywhere instead of
 * hand-rolling `€${n.toFixed(2)}` (which produces wrong locale + symbol-
 * before-amount).
 *
 * @param n         number to format (null/undefined → "0,00 €")
 * @param decimals  fixed digit count after the comma (default 2). Pass 4
 *                  for AI/autopilot per-action costs where sub-cent
 *                  precision matters.
 */
export function fmtEur(n: number | null | undefined, decimals = 2): string {
  const v = typeof n === 'number' && isFinite(n) ? n : 0;
  return new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(v);
}

/** Plain German number with thousand-dot + decimal-comma, no currency symbol. */
export function fmtNumDe(n: number | null | undefined, decimals = 0): string {
  const v = typeof n === 'number' && isFinite(n) ? n : 0;
  return new Intl.NumberFormat('de-DE', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(v);
}
